<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="block-full-width no-border-radius">
        <h2 [ngClass]="{ 'margin-bottom-10': options.showRequiredText === true }">
            {{ 'REGISTER_FORM_TITLE' | translate }}
        </h2>
        <p class="required-text" *ngIf="options.showRequiredText">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

        <rwidget-signup-email-notw-form
            [options]="options"
            (registerEvent)="forwardRegisterEvent($event)"></rwidget-signup-email-notw-form>
    </div>
</ng-container>
<ng-container *ngIf="env.USE_TAILWIND">
    <div class="mb-10 grid grid-cols-2 gap-4 lg:grid-cols-4" *ngIf="env.REGISTRATION?.AUTH_FEATURES?.length">
        <button
            class="min-h-20 flex flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.REGISTRATION?.AUTH_FEATURES?.length !== 0"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedSignUpMethod === 'selectedSignUpEmail'
            }"
            (click)="setSelectedSignUpMethod('selectedSignUpEmail')">
            <mat-icon
                class="material-icons-outlined flex flex-1 items-center"
                [ngClass]="{
                    'dark:text-contrast-black': selectedSignUpMethod === 'selectedSignUpEmail'
                }"
                >email
            </mat-icon>
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedSignUpMethod === 'selectedSignUpEmail'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                E-mail
            </span>
        </button>

        <button
            class="min-h-20 flex flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.REGISTRATION?.AUTH_FEATURES?.includes('VIISP')"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedSignUpMethod === 'selectedSignUpViisp'
            }"
            (click)="setSelectedSignUpMethod('selectedSignUpViisp')">
            <img class="my-1 h-8 w-8" alt="VIISP" src="./assets/img/viisp.png" />
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedSignUpMethod === 'selectedSignUpViisp'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                VIISP
            </span>
        </button>
    </div>

    <rwidget-signup-email-form
        class="text-base"
        *ngIf="showSelectedSignUpMethodForm('selectedSignUpEmail')"
        [captchaToggleAllowed]="captchaToggleAllowed"
        [options]="options"
        (didRegister)="forwardRegisterEvent($event)"></rwidget-signup-email-form>
    <rwidget-signup-viisp-form *ngIf="showSelectedSignUpMethodForm('selectedSignUpViisp')"></rwidget-signup-viisp-form>
</ng-container>
